import React, { useEffect, useState } from "react";
import "../../Pages/CleeQ.css";
import "../../Pages/Responsive.css";
import { makeStyles } from "@material-ui/core/styles";
import Aos from "aos";
import "aos/dist/aos.css";
import ContactUs from "../ContactUs";
import "../../Components/NavBar/NavBar.css";
import NavBar from "../../Components/NavBar/NavBar";
import SocialHeadings from "../../Components/SocialHeadings";
import BBQParty2022 from "./BBQParty2022";
import BBQPartyMay2024 from "./BBQPartyMay2024";
import OfficialAluminiPresidentVisit2023 from "./OfficialAluminiPresidentVisit2023";
import PartyInTheParkMay2023 from "./PartyInTheParkMay2023";
import RetroPartyMay2023 from "./RetroPartyMay2023";
import UnilagGrantPresentation from "./UnilagGrantPresentation";

function EventProperties({ show, onClose, onOpen }) {
  const [eventDay1Show, setEventDay1Show] = useState(false);
  const handleEventDay1 = () => setEventDay1Show(false);

  const [party1Show, setParty1Show] = useState(false);
  const handleParty1 = () => setParty1Show(false);

  const [party2Show, setParty2Show] = useState(false);
  const handleParty2 = () => setParty2Show(false);

  const [party3Show, setParty3Show] = useState(false);
  const handleParty3 = () => setParty3Show(false);

  const [party4Show, setParty4Show] = useState(false);
  const handleParty4 = () => setParty4Show(false);

  const [party5Show, setParty5Show] = useState(false);
  const handleParty5 = () => setParty5Show(false);

  return (
    <div>
      <div>
        <div className="SoleraBody21">
          <div className="container EventOthers landing-page-container">
            <div>
              <div>
                <div className="LandingHedings1" data-aos="zoom-in-up">
                  Events
                </div>
                <div className="NO-Events">Past events</div>
              </div>
              <br /> <br />
              <div className="SeeMore ">
                <div className="NO-Events">BBQ Party 2022</div>
                <br /> <br />
                <div className="container p-0">
                  <div className="row g-2">
                    <div className="col-lg-6">
                      <div className="">
                        <div className="EvetDescription ">
                          On a sunny day in London, Unilag Alumni UK gathered in
                          a lovely park to catch up with old friends. The BBQ
                          Party 2022 was full of fun, laughter, and tasty
                          barbecue along with other great food.
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="">
                        <div className="container-fluid p-0">
                          <div className="row g-2">
                            <div className="col-6 col-lg-4">
                              <div className="EventPics">
                                {" "}
                                <div>
                                  <img
                                    src="/assets/Party2022/1.png"
                                    alt=""
                                    className="Photogallary "
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-6 col-lg-4">
                              <div className=" EventPics">
                                {" "}
                                <img
                                  src="/assets/Party2022/5.png"
                                  alt=""
                                  className="Photogallary "
                                />
                              </div>
                            </div>
                            <div className="col-6 col-lg-4 ImgageDisplayNone">
                              <div className=" EventPics">
                                {" "}
                                <img
                                  src="/assets/Party2022/3.png"
                                  alt=""
                                  className="Photogallary "
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="SeeMore" onClick={() => setEventDay1Show(true)}>
                See Pictures...
              </div>
              <br /> <br />
              <div className="SeeMore ">
                {" "}
                <div className="NO-Events">Party In The Park May 2023</div>
                <br /> <br />
                <div className="container p-0">
                  <div className="row g-2">
                    <div className="col-lg-6">
                      <div className="">
                        <div className="container-fluid p-0">
                          <div className="row g-2">
                            <div className="col-6 col-lg-4">
                              <div className="EventPics">
                                <div>
                                  <img
                                    src="/assets/ParkParty2023/1.png"
                                    alt=""
                                    className="Photogallary"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-6 col-lg-4">
                              <div className="EventPics">
                                <img
                                  src="/assets/ParkParty2023/2.png"
                                  alt=""
                                  className="Photogallary"
                                />
                              </div>
                            </div>
                            <div className="col-6 col-lg-4 ImgageDisplayNone">
                              <div className="EventPics">
                                <img
                                  src="/assets/ParkParty2023/3.png"
                                  alt=""
                                  className="Photogallary"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="">
                        <div className="EvetDescription ">
                          On May 27th, 2023, the Unilag Alumni UK community
                          gathered at Alexandra Palace park in Wood Green,
                          London, for a fun "Party in the Park." Alumni came
                          together to enjoy delicious food, drinks, and great
                          company. The day was filled with laughter, music, and
                          good times as old friends reconnected and new
                          friendships were made.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="SeeMore" onClick={() => setParty3Show(true)}>
                See Pictures...
              </div>
              <br /> <br />
              <div className="SeeMore ">
                {" "}
                <div className="NO-Events">
                  Official Alumni President Visit 2023
                </div>
                <br /> <br />
                <div className="container p-0">
                  <div className="row g-2">
                    <div className="col-lg-6">
                      <div className="">
                        <div className="EvetDescription ">
                          In early 2023, the Unilag Alumni UK had the honor of
                          welcoming the official Unilag Alumni President,
                          Engineer Ifeoluwa Oyedele. During his visit, he met
                          with some of the Unilag Alumni UK executives. The
                          meeting was filled with engaging conversations about
                          the impact of the alumni association on the University
                          of Lagos and how members in the UK could contribute
                          further. It was an inspiring and productive meeting,
                          highlighting the commitment of our alumni to support
                          and improve our alma mater
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="">
                        <div className="container-fluid p-0">
                          <div className="row g-2">
                            <div className="col-6 col-lg-4">
                              <div className="EventPics">
                                {" "}
                                <div>
                                  <img
                                    src="/assets/OfficialVisit/1.png"
                                    alt=""
                                    className="Photogallary "
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-6 col-lg-4">
                              <div className=" EventPics">
                                {" "}
                                <img
                                  src="/assets/OfficialVisit/2.png"
                                  alt=""
                                  className="Photogallary "
                                />
                              </div>
                            </div>
                            <div className="col-6 col-lg-4 ImgageDisplayNone">
                              <div className=" EventPics">
                                {" "}
                                <img
                                  src="/assets/OfficialVisit/3.png"
                                  alt=""
                                  className="Photogallary "
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="SeeMore" onClick={() => setParty2Show(true)}>
                See Pictures...
              </div>
              <br /> <br />
              <div className="SeeMore ">
                {" "}
                <div className="NO-Events">Retro Party May 2023</div>
                <br /> <br />
                <div className="container p-0">
                  <div className="row g-2">
                    <div className="col-lg-6">
                      <div className="">
                        <div className="container-fluid p-0">
                          <div className="row g-2">
                            <div className="col-6 col-lg-4">
                              <div className="EventPics">
                                {" "}
                                <div>
                                  <img
                                    src="/assets/Rotary/1.jpg"
                                    alt=""
                                    className="Photogallary "
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-6 col-lg-4">
                              <div className=" EventPics">
                                {" "}
                                <img
                                  src="/assets/Rotary/2.jpg"
                                  alt=""
                                  className="Photogallary "
                                />
                              </div>
                            </div>
                            <div className="col-6 col-lg-4 ImgageDisplayNone">
                              <div className=" EventPics">
                                {" "}
                                <img
                                  src="/assets/Rotary/3.jpg"
                                  alt=""
                                  className="Photogallary "
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="">
                        <div className="EvetDescription ">
                          On December 2nd, 2023, the Unilag Alumni UK community
                          gathered at the Millennium Suite: Doubletree by Hilton
                          London for a fun "End of the Year Retro Party." Alumni
                          dressed up in colorful 80s outfits, bringing back the
                          style of the decade. The night featured jazz music and
                          a shining disco ball, creating a lively atmosphere.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="SeeMore" onClick={() => setParty4Show(true)}>
                See Pictures...
              </div>
              <br /> <br />
              <div className="SeeMore ">
                {" "}
                <div className="NO-Events">Unilag Grant Presentation</div>
                <br /> <br />
                <div className="container p-0">
                  <div className="row g-2">
                    <div className="col-lg-6">
                      <div className="">
                        <div className="EvetDescription ">
                          "In giving, we receive." The Unilag Alumni UK Chapter
                          decided to express gratitude to its alma mater,
                          University of Lagos, by giving grants to 17 deserving
                          undergraduates in the University. The Grant
                          Presentation on January 17,2024 had in attendance,
                          Eng. Ifeoluwa Oyedele (President, Unilag Alumni
                          Association), Prof. Folasade Ogunsola (Vice
                          Chancellor, University of Lagos), Prof. Ayodele
                          Atsenuwa (Deputy Vice Chancellor, University of Lagos
                          - Development Services), Mr. Lekan Ajisafe
                          (Ex-Officio, Unilag Alumni Association) and Mrs.
                          Yetunde Abatan (Head of Alumni Office, Unilag).
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="">
                        <div className="container-fluid p-0">
                          <div className="row g-2">
                            <div className="col-6 col-lg-4">
                              <div className="EventPics">
                                {" "}
                                <div>
                                  <img
                                    src="/assets/Grant/1.png"
                                    alt=""
                                    className="Photogallary "
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-6 col-lg-4">
                              <div className=" EventPics">
                                {" "}
                                <img
                                  src="/assets/Grant/2.png"
                                  alt=""
                                  className="Photogallary "
                                />
                              </div>
                            </div>
                            <div className="col-6 col-lg-4 ImgageDisplayNone">
                              <div className=" EventPics">
                                {" "}
                                <img
                                  src="/assets/Grant/3.png"
                                  alt=""
                                  className="Photogallary "
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="SeeMore" onClick={() => setParty5Show(true)}>
                See Pictures...
              </div>
              <br /> <br />
              <div className="SeeMore ">
                {" "}
                <div className="NO-Events">BBQ Party May 2024</div>
                <br /> <br />
                <div className="container p-0">
                  <div className="row g-2">
                    <div className="col-lg-6">
                      <div className="">
                        <div className="container-fluid p-0">
                          <div className="row g-2">
                            <div className="col-6 col-lg-4">
                              <div className="EventPics">
                                {" "}
                                <div>
                                  <img
                                    src="/assets/Part2024/1.png"
                                    alt=""
                                    className="Photogallary "
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-6 col-lg-4">
                              <div className=" EventPics">
                                {" "}
                                <img
                                  src="/assets/Part2024/2.png"
                                  alt=""
                                  className="Photogallary "
                                />
                              </div>
                            </div>
                            <div className="col-6 col-lg-4 ImgageDisplayNone">
                              <div className=" EventPics">
                                {" "}
                                <img
                                  src="/assets/Part2024/3.png"
                                  alt=""
                                  className="Photogallary "
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="">
                        <div className="EvetDescription ">
                          On May 4th, 2024, Unilag alumni from all over the UK
                          met at Waterloo Park, Highgate Hill, London, for a fun
                          barbecue party. It was a great day filled with good
                          food, laughter, and the chance to catch up with old
                          friends and make new ones. The photos show the happy
                          moments and strong connections that make our alumni
                          community special.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="SeeMore" onClick={() => setParty1Show(true)}>
                See Pictures...
              </div>
              <br /> <br />
            </div>{" "}
            <br />
            <div className="SeeMore">See More</div>
            <br /> <br /> <br />
            <br />
            <div className="LandingHedings1" data-aos="zoom-in-up">
              Up-Coming Events
            </div>
            <br /> <br />
            <div className="container-fluid p-0">
              <div className="EventPics NO-Events">
                Currently, our calendar is taking a breather, but rest assured,
                we're cooking up some incredible events that you won't want to
                miss! Stay tuned for what's in store!
              </div>
            </div>
          </div>
        </div>

        <BBQParty2022
          show={eventDay1Show}
          onClose={handleEventDay1}
          onOpen={() => setEventDay1Show(true)}
        />

        <BBQPartyMay2024
          show={party1Show}
          onClose={handleParty1}
          onOpen={() => setParty1Show(true)}
        />

        <OfficialAluminiPresidentVisit2023
          show={party2Show}
          onClose={handleParty2}
          onOpen={() => setParty2Show(true)}
        />

        <PartyInTheParkMay2023
          show={party3Show}
          onClose={handleParty3}
          onOpen={() => setParty3Show(true)}
        />

        <RetroPartyMay2023
          show={party4Show}
          onClose={handleParty4}
          onOpen={() => setParty4Show(true)}
        />

        <UnilagGrantPresentation
          show={party5Show}
          onClose={handleParty5}
          onOpen={() => setParty5Show(true)}
        />
      </div>
    </div>
  );
}

export default EventProperties;
